import { useCallback } from "react";

import { useToast } from "@/components/flexkit/toast";
import { useGetPreferenceByKey, useSetPreference } from "@/queries/user-preferences-queries";
import { formatError } from "@/utils/errors";

const DEFAULT_EDITOR = "DEFAULT_EDITOR";

export function useDefaultEditor() {
    const { data: preference, isPending: isPendingPreferences } = useGetPreferenceByKey(DEFAULT_EDITOR);

    return {
        editorId: preference?.value,
        isPending: isPendingPreferences,
    };
}

export function useSetDefaultEditor() {
    const { toast } = useToast();
    const setPreference = useSetPreference();

    return useCallback(
        async (editorId: string) => {
            try {
                await setPreference.mutateAsync({ key: DEFAULT_EDITOR, value: editorId });
            } catch (e) {
                toast({
                    title: "Failed to update default editor",
                    description: formatError(e),
                });
            }
        },
        [setPreference, toast],
    );
}
